import axios from '../../axios';

const path = '/users';
const service = {
  async getUser() {
    return axios({ method: 'get', url: `${path}/me` });
  },

  async archiveUsers(payload) {
    return axios({ method: 'delete', url: `${path}/archive`, data: payload });
  },

  async deleteUsers(payload) {
    return axios({ method: 'delete', url: `${path}`, data: payload });
  },

  async getAllUsers() {
    return axios({ method: 'get', url: `${path}/allUsers` });
  },

  async getUsers(params) {
    return axios({ method: 'get', url: path, params });
  },

  getAssignableUsers(params) {
    return axios({ method: 'get', url: `${path}/assignable`, params });
  },

  async createNewUser(payload) {
    return axios({ method: 'post', url: `${path}/createNew`, data: payload });
  },

  async sendSetPassword(payload) {
    return axios({ method: 'post', url: `${path}/sendSetPassword`, data: payload });
  },

  async contactUs(payload) {
    return axios({ method: 'post', url: `${path}/contactUs`, data: payload });
  },

  async subscribe(payload) {
    return axios({ method: 'post', url: '/subscription/user', data: payload });
  },

  async updateSubscription(payload) {
    return axios({ method: 'put', url: '/subscription/user', data: payload });
  },

  updateUserSessionPushToken(token) {
    return axios({ method: 'put', url: `${path}/me/push-token`, data: { token } });
  },

  getTablePreferences() {
    return axios.get(`${path}/me/table-preferences`);
  },

  createUserDashboardPreferences(data) {
    return axios({ method: 'post', url: `${path}/me/dashboard-preferences`, data: { data } });
  },

  fetchDashboardPreferences() {
    return axios.get(`${path}/me/dashboard-preferences`);
  },

  fetchUserTableSettings() {
    return axios.get(`${path}/me/table-settings`);
  },

  upsertTablePageSize(data) {
    return axios({ method: 'post', url: `${path}/me/table-settings`, data });
  },

  updateTablePreferences(tableId, columns) {
    return axios.put(`${path}/me/table-preferences/${tableId}`, { columns });
  },

  resetTablePreferences(tableId) {
    return axios.delete(`${path}/me/table-preferences/${tableId}`);
  },

  confirmRoles(ids) {
    return axios({ method: 'put', url: `/admin/roles/confirm`, data: { ids } });
  },

  deleteUserDashboardPreferences() {
    return axios({ method: 'delete', url: `${path}/me/dashboard-preferences` });
  }
};

export default service;
